import { StyledHighlighter } from './Highlighter.styles';

export function Highlighter({ text, searchText }: { text?: string; searchText: string }) {
  return (
    <StyledHighlighter
      autoEscape
      searchWords={[searchText]}
      highlightClassName="mark-highlight"
      textToHighlight={text ? text.toString() : ''}
    />
  );
}
